<template>
    <div>
        <introduction-title ch-title="联系我们" en-title="CONTACT US" style="margin-top: 20px"></introduction-title>
        <div class="contactWap">
            <div class="contactImg">
                <viewer>
                    <img src="../../../assets/image/contact-map.png" alt="">
                </viewer>
            </div>
            <div class="contactText">
                <div class="li">
                    <div class="icon">
                        <i class="iconfont icon-a-lianxiwomendizhi"></i>
                    </div>
                    <div class="iconText">
                        <span>
                            地址：重庆市巴南区木洞镇天益路9号重庆国际<br>生物城E3栋2单元<br>
                        </span>
                    </div>
                </div>
                <div class="li" style="height:150px;">
                    <div class="icon">
                        <i class="iconfont icon-a-lianxiwomendianhua"></i>
                    </div>
                    <div class="iconText">
                        <span>联系电话：<br>
023-67665596		<br>
186 2333 1236（冯经理）<br>
136 2765 9255（杨经理）<br>
185 8087 5987（张经理）<br></span>
                    </div>
                </div>
                <div class="li">
                    <div class="icon" style="float: left">
                        <i class="iconfont icon-a-lianxiwomenyouxiang"></i>
                    </div>
                    <div  class="iconText">
                        <span>邮箱：
                            swengin@163.com<br></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import IntroductionTitle from "@/components/wap/introductionTitle.vue";

    export default {
        name: "wapContactUs",
        components: {IntroductionTitle}
    }
</script>

<style scoped>
    .contactWap {
        width:390px;
        height:100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin:20px auto 30px;
    }
    .contactWap .contactImg{
        width:355px;
        margin:0 auto 0;
    }
    .contactWap .contactImg img{
        width:355px;
        border-radius: 10px;
    }
    .contactWap .contactText {
        width: 355px;
        height: 330px;
        text-align: left;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 1px;
        margin:0 auto 0;
    }

    .contactWap .contactText .li {
        width: 100%;
        height:65px;
        display: flex;
        margin-bottom:10px;
    }
    .contactWap .contactText .li .iconText{
        height:48px;
        line-height: 20px;
    }
    .contactWap .contactText .icon {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        border-radius: 30px;
        border: 1px solid #EEEFF0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top:10px;
    }

    .contactWap .contactText .icon i {
        font-size: 16px;
        color: #0067AC;
    }

    .contactWap .contactText .li span {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
        line-height: 5px;
    }
</style>
